import shop from '../Assets/ecommerce.png';
import ecommerce from '../Assets/fasfion.png';
import email from '../Assets/email.png';
import booking from '../Assets/booking.png';
import slider from '../Assets/slider.png';
import transport from '../Assets/transport.png';
import hungry from '../Assets/hungry.png';
import cleaning from '../Assets/cleaning.png';
import portfolio from '../Assets/portfolio.png';


const MyWorkData = [
  {
     title:"Static portfolio", skill1:"HTML",
     skill2:"CSS3",  skill3:"Bootstrap",
     skill5:"React", skill6:"Node.Js",
     skill7:"Mongodb", skill8:"Express",
     skill9:"CORS",skill9:"Github",
     skills:"FireBase", skill4:"JavaScript",
     img: portfolio,
     url:"https://uddipan01.github.io/Assignment01/assignment"
  },
  {
     title:"Ecommerce", skill1:"HTML",
     skill2:"CSS3", skill3:"Bootstrap",
     skill5:"React", skill6:"Node.Js",
     skill7:"Mongodb", skill8:"Express",
     skill9:"CORS",skill9:"Github",
     skills:"FireBase", skill4:"JavaScript",
     img: ecommerce,
     url:"https://uddipan01.github.io/Assignment-2/"
  },
  {
     title:"PHD To HTML", skill1:"HTML",
     skill2:"CSS3", skill3:"Bootstrap",
     skill5:"React", skill6:"Node.Js",
     skill7:"Mongodb", skill8:"Express",
     skill9:"CORS",skill9:"Github",
     skills:"FireBase", skill4:"JavaScript",
     img: email,
     url:"https://uddipan01.github.io/psd-email/"
  },
  {
     title:"Booking a Ticket", skill1:"HTML",
     skill2:"CSS3", skill3:"Bootstrap",
     skill5:"React", skill6:"Node.Js",
     skill7:"Mongodb", skill8:"Express",
     skill9:"CORS",skill9:"Github",
     skills:"FireBase", img: slider,
     skill4:"JavaScript",
     img: booking,
     url:"https://uddipan01.github.io/Assignment-04/"
  },
  { title:"BD SHOP", skill1:"HTML", skill2:"CSS3",
     skill3:"Bootstrap", skill4:"JavaScript",
     skill5:"React", skill6:"Node.Js",
     skill7:"Mongodb",skill8:"Express",
     skill9:"CORS", skill9:"Github",
     skills:"FireBase", img: shop,
     url:"https://full-stack-client-8eafd.web.app/"
  },
  { title:"Making-Slider", skill1:"HTML", skill2:"CSS3",
     skill3:"Bootstrap", skill4:"JavaScript",
     skill5:"React", skill6:"Node.Js",
     skill7:"Mongodb", skill8:"Express",
     skill9:"CORS",skill9:"Github",
     skills:"FireBase", img: slider,
     url:"https://uddipan01.github.io/Assignment-6/"
  },
  { title:"Transport-Service", skill1:"HTML", skill2:"CSS3",
     skill3:"Bootstrap", skill4:"JavaScript",
     skill5:"React", skill6:"Node.Js",
     skill7:"Mongodb", skill8:"Express",
     skill9:"CORS", skill9:"Github", skills:"FireBase",
     img: transport, url:"https://assignmentnine-8b45d.web.app/"
  },
  { title:"Food-Corner", skill1:"HTML", skill2:"CSS3",
  skill3:"Bootstrap", skill4:"JavaScript",
  skill5:"React", skill6:"Node.Js",
  skill7:"Mongodb", skill8:"Express",
  skill9:"CORS", skill9:"Github", skills:"FireBase",
  img: hungry, url:"https://uddipan01.github.io/Assignment-5/"
},
{ title:"Cleaning-Solution", skill1:"HTML", skill2:"CSS3",
skill3:"Bootstrap", skill4:"JavaScript",
skill5:"React", skill6:"Node.Js",
skill7:"Mongodb", skill8:"Express",
skill9:"CORS", skill9:"Github", skills:"FireBase",
img: cleaning, url:"https://complete-client-website.web.app/"
},
]

export default MyWorkData;
